import React from "react";
import "./css/NotificationBadge.css";

/**
 * Notification badge component for displaying unread notification count
 */
function NotificationBadge({ count, className = "" }) {
  if (!count || count === 0) {
    return null;
  }

  // Display 99+ for counts over 99
  const displayCount = count > 99 ? "99+" : count;

  return (
    <span
      className={`notification-badge ${className}`}
      title={`${count} unread notifications`}
    >
      {displayCount}
    </span>
  );
}

export default NotificationBadge;
